<button class="hamburger neo-button">
    <span class="material-icons">menu</span>
</button>